/**
 * Generated by orval v8.12.3 🍺
 * Do not edit manually.
 * TorqueTitan API
 * Auto repair shop management API
 * OpenAPI spec version: 1.0.0
 */
import { useMutation, useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  ApiError,
  NotificationList,
  NotificationPreferences,
  UpsertNotificationPreferencesRequest,
} from './torqueTitanAPI.schemas';

import { apiFetcher } from '../apiFetcher';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getListNotificationsUrl = () => {
  return `/notifications`;
};

/**
 * @summary List notifications for the current shop
 */
export const listNotifications = async (options?: RequestInit): Promise<NotificationList> => {
  return apiFetcher<NotificationList>(getListNotificationsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getListNotificationsQueryKey = () => {
  return [`/notifications`] as const;
};

export const getListNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof listNotifications>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getListNotificationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof listNotifications>>> = ({ signal }) =>
    listNotifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof listNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof listNotifications>>>;
export type ListNotificationsQueryError = ApiError;

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listNotifications>>,
          TError,
          Awaited<ReturnType<typeof listNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary List notifications for the current shop
 */

export function useListNotifications<TData = Awaited<ReturnType<typeof listNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof listNotifications>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getListNotificationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getStreamNotificationsUrl = () => {
  return `/notifications/stream`;
};

/**
 * Opens a Server-Sent Events stream that pushes new notifications in real time. Supports Last-Event-ID header for resuming after reconnection. Stream auto-closes after ~14 minutes; client should reconnect.
 * @summary SSE stream of new notifications for the current user
 */
export const streamNotifications = async (options?: RequestInit): Promise<string> => {
  return apiFetcher<string>(getStreamNotificationsUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getStreamNotificationsQueryKey = () => {
  return [`/notifications/stream`] as const;
};

export const getStreamNotificationsQueryOptions = <
  TData = Awaited<ReturnType<typeof streamNotifications>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getStreamNotificationsQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof streamNotifications>>> = ({ signal }) =>
    streamNotifications({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof streamNotifications>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type StreamNotificationsQueryResult = NonNullable<Awaited<ReturnType<typeof streamNotifications>>>;
export type StreamNotificationsQueryError = ApiError;

export function useStreamNotifications<TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ApiError>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamNotifications<TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof streamNotifications>>,
          TError,
          Awaited<ReturnType<typeof streamNotifications>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useStreamNotifications<TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary SSE stream of new notifications for the current user
 */

export function useStreamNotifications<TData = Awaited<ReturnType<typeof streamNotifications>>, TError = ApiError>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof streamNotifications>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getStreamNotificationsQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getMarkAllNotificationsReadUrl = () => {
  return `/notifications/mark-all-read`;
};

/**
 * @summary Mark all notifications as read for the current shop
 */
export const markAllNotificationsRead = async (options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getMarkAllNotificationsReadUrl(), {
    ...options,
    method: 'PATCH',
  });
};

export const getMarkAllNotificationsReadMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, void, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, void, TContext> => {
  const mutationKey = ['markAllNotificationsRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markAllNotificationsRead>>, void> = () => {
    return markAllNotificationsRead(requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkAllNotificationsReadMutationResult = NonNullable<Awaited<ReturnType<typeof markAllNotificationsRead>>>;

export type MarkAllNotificationsReadMutationError = ApiError;

/**
 * @summary Mark all notifications as read for the current shop
 */
export const useMarkAllNotificationsRead = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, void, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof markAllNotificationsRead>>, TError, void, TContext> => {
  return useMutation(getMarkAllNotificationsReadMutationOptions(options), queryClient);
};
export const getMarkNotificationReadUrl = (id: string) => {
  return `/notifications/${id}/read`;
};

/**
 * @summary Mark a notification as read
 */
export const markNotificationRead = async (id: string, options?: RequestInit): Promise<void> => {
  return apiFetcher<void>(getMarkNotificationReadUrl(id), {
    ...options,
    method: 'PATCH',
  });
};

export const getMarkNotificationReadMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, { id: string }, TContext>;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, { id: string }, TContext> => {
  const mutationKey = ['markNotificationRead'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof markNotificationRead>>, { id: string }> = (props) => {
    const { id } = props ?? {};

    return markNotificationRead(id, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type MarkNotificationReadMutationResult = NonNullable<Awaited<ReturnType<typeof markNotificationRead>>>;

export type MarkNotificationReadMutationError = ApiError;

/**
 * @summary Mark a notification as read
 */
export const useMarkNotificationRead = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<Awaited<ReturnType<typeof markNotificationRead>>, TError, { id: string }, TContext>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<Awaited<ReturnType<typeof markNotificationRead>>, TError, { id: string }, TContext> => {
  return useMutation(getMarkNotificationReadMutationOptions(options), queryClient);
};
export const getGetNotificationPreferencesUrl = () => {
  return `/notifications/preferences`;
};

/**
 * @summary Get notification preferences for the current user
 */
export const getNotificationPreferences = async (options?: RequestInit): Promise<NotificationPreferences | void> => {
  return apiFetcher<NotificationPreferences | void>(getGetNotificationPreferencesUrl(), {
    ...options,
    method: 'GET',
  });
};

export const getGetNotificationPreferencesQueryKey = () => {
  return [`/notifications/preferences`] as const;
};

export const getGetNotificationPreferencesQueryOptions = <
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ApiError,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferences>>, TError, TData>>;
  request?: SecondParameter<typeof apiFetcher>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetNotificationPreferencesQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getNotificationPreferences>>> = ({ signal }) =>
    getNotificationPreferences({ signal, ...requestOptions });

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getNotificationPreferences>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetNotificationPreferencesQueryResult = NonNullable<Awaited<ReturnType<typeof getNotificationPreferences>>>;
export type GetNotificationPreferencesQueryError = ApiError;

export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ApiError,
>(
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferences>>, TError, TData>> &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof getNotificationPreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferences>>, TError, TData>> &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getNotificationPreferences>>,
          TError,
          Awaited<ReturnType<typeof getNotificationPreferences>>
        >,
        'initialData'
      >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferences>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
/**
 * @summary Get notification preferences for the current user
 */

export function useGetNotificationPreferences<
  TData = Awaited<ReturnType<typeof getNotificationPreferences>>,
  TError = ApiError,
>(
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getNotificationPreferences>>, TError, TData>>;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetNotificationPreferencesQueryOptions(options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  return { ...query, queryKey: queryOptions.queryKey };
}

export const getUpsertNotificationPreferencesUrl = () => {
  return `/notifications/preferences`;
};

/**
 * @summary Upsert notification preferences
 */
export const upsertNotificationPreferences = async (
  upsertNotificationPreferencesRequest?: UpsertNotificationPreferencesRequest,
  options?: RequestInit
): Promise<NotificationPreferences> => {
  return apiFetcher<NotificationPreferences>(getUpsertNotificationPreferencesUrl(), {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(upsertNotificationPreferencesRequest),
  });
};

export const getUpsertNotificationPreferencesMutationOptions = <TError = ApiError, TContext = unknown>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof upsertNotificationPreferences>>,
    TError,
    { data?: UpsertNotificationPreferencesRequest },
    TContext
  >;
  request?: SecondParameter<typeof apiFetcher>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof upsertNotificationPreferences>>,
  TError,
  { data?: UpsertNotificationPreferencesRequest },
  TContext
> => {
  const mutationKey = ['upsertNotificationPreferences'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof upsertNotificationPreferences>>,
    { data?: UpsertNotificationPreferencesRequest }
  > = (props) => {
    const { data } = props ?? {};

    return upsertNotificationPreferences(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpsertNotificationPreferencesMutationResult = NonNullable<
  Awaited<ReturnType<typeof upsertNotificationPreferences>>
>;
export type UpsertNotificationPreferencesMutationBody = UpsertNotificationPreferencesRequest | undefined;
export type UpsertNotificationPreferencesMutationError = ApiError;

/**
 * @summary Upsert notification preferences
 */
export const useUpsertNotificationPreferences = <TError = ApiError, TContext = unknown>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof upsertNotificationPreferences>>,
      TError,
      { data?: UpsertNotificationPreferencesRequest },
      TContext
    >;
    request?: SecondParameter<typeof apiFetcher>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof upsertNotificationPreferences>>,
  TError,
  { data?: UpsertNotificationPreferencesRequest },
  TContext
> => {
  return useMutation(getUpsertNotificationPreferencesMutationOptions(options), queryClient);
};
